/**
 * A parte do perfil que no Discord se paga.
 *
 * Banner, cor de perfil e moldura do avatar são exactamente aquilo por que o
 * Nitro cobra — e nenhuma delas custa nada a servir: a cor são sete caracteres
 * numa coluna, a moldura é um id que o cliente desenha em SVG, e o banner passa
 * pelo mesmo caminho de ficheiros que já serve os avatares. Aqui é de graça, e
 * é essa a razão de este ficheiro existir separado: o que se dá de borla ainda
 * assim tem de ter regras, senão o "de graça" chega ao ecrã dos outros como um
 * hexadecimal inventado a pintar o cartão de preto sobre preto.
 *
 * As duas listas — as cores e as molduras — vivem no `shared` porque o servidor
 * VALIDA contra elas e o cliente DESENHA a partir delas. Uma cópia de cada lado
 * seria a maneira mais rápida de ter uma moldura que o servidor aceita e o
 * cliente não sabe desenhar.
 */
/**
 * O catálogo. Oito, e não oitenta: uma escolha entre cinco vê-se toda de uma
 * vez e decide-se em dois segundos; uma grelha de cinquenta é uma loja, que é
 * precisamente o que aqui não há.
 */
export const AVATAR_FRAMES = [
    { id: "verde", name: "Verde", colors: ["#22c55e", "#0e7c47"] },
    { id: "amanhecer", name: "Amanhecer", colors: ["#f59e0b", "#ef4444"] },
    { id: "oceano", name: "Oceano", colors: ["#38bdf8", "#4f46e5"] },
    { id: "ameixa", name: "Ameixa", colors: ["#c084fc", "#7c3aed"] },
    { id: "cobre", name: "Cobre", colors: ["#fbbf24", "#b45309"] },
    { id: "gelo", name: "Gelo", colors: ["#e2e8f0", "#64748b"] },
    { id: "menta", name: "Menta", colors: ["#5eead4", "#0f766e"] },
    { id: "brasa", name: "Brasa", colors: ["#fb7185", "#9f1239"] },
];
export function avatarFrame(id) {
    if (!id)
        return null;
    return AVATAR_FRAMES.find((f) => f.id === id) ?? null;
}
/**
 * As cores de perfil sugeridas.
 *
 * Sugeridas, não impostas: o campo aceita qualquer hexadecimal válido (ver
 * `isAccentColor`), e estas são o atalho para quem não quer abrir um seletor.
 * São as mesmas famílias das molduras, para um perfil poder combinar as duas
 * sem esforço nenhum de quem o está a montar.
 */
export const ACCENT_COLORS = [
    "#22c55e",
    "#38bdf8",
    "#818cf8",
    "#c084fc",
    "#f472b6",
    "#fb7185",
    "#f59e0b",
    "#14b8a6",
    "#94a3b8",
];
/**
 * Um hexadecimal de seis dígitos, com cardinal. Nada de `rgb()`, nada de nomes
 * CSS e nada de três dígitos: o valor vai directo para um `style` do lado de
 * quem VÊ o perfil, portanto o formato tem de ser exactamente um, e verificável
 * numa linha. `#fff` e `red` funcionariam no browser e abririam a porta a
 * `red;position:fixed`, que é como uma cor se transforma num problema.
 */
export function isAccentColor(value) {
    return /^#[0-9a-fA-F]{6}$/.test(value);
}
/**
 * O ENQUADRAMENTO da capa, em percentagem: 0 encosta ao topo da imagem, 100 ao
 * fundo, 50 é o meio.
 *
 * Existe porque uma capa é um rectângulo largo e baixo e as fotografias não
 * são: cortar sempre pelo meio decapita metade das pessoas que põem lá uma foto
 * sua. É um número e não um par de coordenadas de propósito — a imagem cobre
 * sempre a largura toda (`background-size: cover`), portanto só há uma direcção
 * onde há o que escolher.
 */
export const BANNER_POS_PADRAO = 50;
export function isBannerPos(value) {
    return Number.isInteger(value) && value >= 0 && value <= 100;
}
//# sourceMappingURL=profile.js.map